const languages = [
  {
    "code": "en",
    "name": "English",
    "nativeName": "English"
  },
  {
    "code": "fr",
    "name": "French",
    "nativeName": "français, langue française"
  },
  {
    "code": "de",
    "name": "German",
    "nativeName": "Deutsch"
  },
  {
    "code": "it",
    "name": "Italian",
    "nativeName": "Italiano"
  },
  {
    "code": "es",
    "name": "Spanish; Castilian",
    "nativeName": "español, castellano"
  },
  {
    "code": "pl",
    "name": "Polish",
    "nativeName": "polski"
  },
  {
    "code": "pt",
    "name": "Portuguese",
    "nativeName": "Português"
  },
]

export default languages;